/**
 * Keeps --m-header-height equal to the header's ACTUAL height.
 *
 * WHY THIS IS NEEDED. The theme measures headerWrapper.offsetHeight once, during
 * the header element's constructor, and writes the result to
 * <html style="--m-header-height: ...">. It never recomputes: a resize event
 * does not update it. `.m-header` takes its min-height from that variable, and
 * that min-height is the ONLY thing reserving page space for a header whose
 * wrapper is absolutely positioned.
 *
 * So any change to the header's real height leaves the reservation behind, and
 * the header silently overhangs the top of the page by the difference. It was
 * already 1px short before the tier chips existed (47 reserved against a 48px
 * header). With the chips inside the wrapper it was 47 against 76, which is what
 * put the mobile breadcrumb underneath the header.
 *
 * Writing the true height fixes both the overhang and
 * `.m-header.stuck .m-menu-drawer { height: calc(100vh - var(--m-header-height)) }`,
 * which reads the same variable.
 *
 * No feedback loop: the wrapper is position:absolute/fixed, so its height comes
 * from its own content and is unaffected by .m-header's min-height. The guard on
 * `last` keeps it from writing the same value repeatedly anyway.
 */
(function headerHeightSync() {
  if (window.__mHeaderHeightSync) return;
  window.__mHeaderHeightSync = true;

  function sync() {
    var wrapper = document.querySelector('.m-header__wrapper');
    if (!wrapper) return;

    var height = Math.round(wrapper.getBoundingClientRect().height);
    // A zero reading means the header has not laid out yet. Writing it would
    // remove the reservation entirely, which is worse than being stale.
    if (!height) return;

    // Compare against what is actually ON the element, not against the last
    // value WE wrote. The theme's header constructor writes this same inline
    // property, and it can run after us - on a collection page at 414px it put
    // back 47px (the inner header row) over our 76px (the wrapper, chips
    // included), which parked the sticky sort bar 29px underneath the header
    // where it was invisible. Guarding on our own last write meant the wrapper
    // height had not changed, so we never corrected it.
    if (document.documentElement.style.getPropertyValue('--m-header-height').trim() === height + 'px') return;

    document.documentElement.style.setProperty('--m-header-height', height + 'px');
  }

  sync();
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);

  // Fonts land late and change the header's height when they do.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);

  if (window.ResizeObserver) {
    var wrapper = document.querySelector('.m-header__wrapper');
    if (wrapper) new ResizeObserver(sync).observe(wrapper);
  }

  // Re-assert if anything else rewrites the property. sync() is a no-op when the
  // value already matches, so our own write settles on the first pass.
  if (window.MutationObserver) {
    new MutationObserver(sync).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style']
    });
  }
})();
